import { Link, useLocation } from "react-router-dom";
import { ReactElement, ReactNode } from "react";

export function NavLink(props: {
  to: string;
  className?: string;
  children: ReactNode;
}): ReactElement {
  const location = useLocation();

  return (
    <Link
      to={props.to}
      className={`hover:text-blue-400 ${
        location.pathname === props.to ? "text-blue-400" : "text-gray-600"
      } ${props.className}`}
    >
      {props.children}
    </Link>
  );
}
